/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NExcelResultDto } from '../../models/i-18-n-excel-result-dto';

export interface I18NAdminControllerExcelUploadV1$Params {
      body: {
'file'?: Blob;
}
}

export function i18NAdminControllerExcelUploadV1(http: HttpClient, rootUrl: string, params: I18NAdminControllerExcelUploadV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NExcelResultDto>> {
  const rb = new RequestBuilder(rootUrl, i18NAdminControllerExcelUploadV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<I18NExcelResultDto>;
    })
  );
}

i18NAdminControllerExcelUploadV1.PATH = '/api/v1/i18n/admin/excel';
